import { render } from "./WebsiteNew.vue?vue&type=template&id=11ac297c"
import script from "./WebsiteNew.vue?vue&type=script&lang=js"
export * from "./WebsiteNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__